<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <div class="mt-1 mb-0 mx-2">
          <b-form>
            <b-row>
              <b-col
                cols="6"
                md="6"
                xl="8"
                class="text-right mt-1"
              >
                <label>Học kỳ</label>
              </b-col>
              <b-col
                cols="6"
                md="6"
                xl="4"
                class="text-right"
              >
                <v-select
                  v-model="filter.courseSemesterId"
                  :options="courseSemesters"
                  :reduce="option => option.value"
                  @input="getMainDataFromStore"
                />
              </b-col>
            </b-row>
          </b-form>
        </div>

        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row class="">
              <b-col cols="12">
                <vue-good-table
                  mode="remote"
                  class="my-table"
                  :columns="columns"
                  :rows="mainData"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  style-class="my-table vgt-table striped bordered"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'status'">
                      {{ getStatusName(props.row.status) }}
                    </span>
                    <!--                    <span v-else-if="props.column.field === 'totalSubject'">-->
                    <!--                      <router-link target="_blank" :to="{ name: 'infoStudentRegisterSubject', params: { courseSemesterId: filter.courseSemesterId, studentId: props.row.studentId }}" >{{ props.formattedRow[props.column.field] }}</router-link>-->
                    <span v-else-if="props.column.field === 'action'">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        class=""
                        variant="success"
                        size="sm"
                        @click="openStudentRegisterSubject({ courseSemesterId: filter.courseSemesterId, studentId: props.row.studentId })"
                      >
                        <span class="text-nowrap text-right">Chi tiết
                        </span>
                      </b-button>
                    </span>
                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị 1 đến </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap">của {{ mainData.length }} bản ghi</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
      <b-modal
        id="modal-student-subject-detail"
        ref="modal-student-subject-detail"
        ok-only
        ok-title="Chấp nhận"
        centered
        size="lg"
        title="Theo dõi sinh viên đăng ký tín chỉ"
        :hide-footer="true"
      >
        <InfoStudentRegisterSubject :data-send="dataSend" />
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BContainer, BFormSelect, BOverlay, BPagination, BRow, BForm,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import InfoStudentRegisterSubject from '@/views/student-class/InfoStudentRegisterSubject.vue'

export const Attr = Object.freeze({
  store: 'studentClass',
})
export default {
  name: 'StudentRegisterSubject',
  directives: {
    Ripple,
  },
  components: {
    InfoStudentRegisterSubject,
    BForm,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
    vSelect,
  },
  props: {
    dataSendClass: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
  },
  data() {
    return {
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        classId: this.$route.params.id || this.dataSendClass.id,
        sort: '1_asc',
        courseSemesterId: '',
      },
      currentMainData: undefined,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      dataSend: { studentId: 0, courseSemesterId: 0 },
    }
  },
  computed: {
    ...mapGetters({
      mainData: `${Attr.store}/dataLists`,
      totalRows: `${Attr.store}/totalRows`,
      statuses: `${Attr.store}/statuses`,
      resourceName: `${Attr.store}/resourceName`,
      courseSemesters: 'dropdown/courseSemesters',
    }),
    statusFilterDropdownItems() {
      return this.statuses.map(item => ({ value: item.value, text: item.label }))
    },
    columns() {
      return [
        {
          label: '#',
          field: 'rowNum',
          width: '30px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Mã lớp',
          field: 'classCode',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: `Họ tên ${this.resourceName.shortName}`,
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: `Mã ${this.resourceName.shortName}`,
          field: 'code',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: this.statusFilterDropdownItems,
          },
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Tổng số môn học',
          field: 'totalSubject',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Tổng số tín chỉ',
          field: 'totalCredit',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Thao tác',
          field: 'action',
          maxWidth: '60px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]
    },
  },
  async created() {
    await this.getCourseSemester({ courseId: this.dataSendClass.courseId, status: null })
    this.filter.courseSemesterId = this.courseSemesters.find(item => item.status == 1).value

    this.isLoading = true
    try {
      await Promise.all([
        this.getMainData(this.filter),
      ])
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      getMainData: `${Attr.store}/getStudentSubject`,
      getCourseSemester: 'dropdown/getCourseSemestersNew',
    }),
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getMainDataFromStore()
    },
    async getMainDataFromStore() {
      this.isLoading = true
      try {
        await this.getMainData(this.filter)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getMainDataFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        const selectedColumn = this.columns.findIndex(e => e.field === field)

        this.updateParams({ sort: `${selectedColumn}_${type}` })
      }
      await this.getMainDataFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'code')) this.updateParams({ code: columnFilters.code })
      if (Object.hasOwn(columnFilters, 'status')) this.updateParams({ status: columnFilters.status })
      await this.getMainDataFromStore()
    },
    getStatusName(id) {
      const result = this.statuses.find(status => status.value === id)
      if (result) {
        return result.label
      }
      return '---'
    },
    async onSucceed() {
      await this.getMainDataFromStore()
    },
    openStudentRegisterSubject(data) {
      this.dataSend.studentId = data.studentId
      this.dataSend.courseSemesterId = data.courseSemesterId
      this.$refs['modal-student-subject-detail'].show()
    },
  },
}
</script>
